/** Native beforeunload hint (browser may show a generic message). */
export const STUDENT_SIGNUP_BEFORE_UNLOAD_HINT =
  'Your signup progress is not saved. Finish registration to avoid starting over.';

export const STUDENT_SIGNUP_EXIT_DIALOG_TITLE = 'Leave signup?';

export const STUDENT_SIGNUP_EXIT_DIALOG_BODY =
  'Your signup progress is not saved until you finish registration and payment. If you leave now, you will need to start again. Stay on this page to complete signup and create your account.';
